import { render, staticRenderFns } from "./HeaderInformationNavigationEdunetma.vue?vue&type=template&id=23ddb631&scoped=true"
import script from "./HeaderInformationNavigationEdunetma.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationEdunetma.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationEdunetma.vue?vue&type=style&index=0&id=23ddb631&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddb631",
  null
  
)

export default component.exports